import React from "react"
import RepairOfferFileDrop from "./RepairOfferFileDrop"
import moment from "moment"

const RepairOfferListItem = ({ entry, myUser, statusIndex, reload }) => {
  const isUserSeller = () => myUser?.company?.id == entry?.sellerCompanyID
  const isUserRequestor = () => myUser?.company?.id == entry?.requestorCompanyID

  return (
    <>
      {entry?.offerFileURL ? (
        <li
          className={
            "event-list " + (entry?.statusIndex == statusIndex ? "active" : "")
          }
        >
          <a
            href={entry?.offerFileURL}
            target="_blank"
            rel="noreferrer"
            className="text-dark"
          >
            <div
              className={
                "event-timeline-dot " +
                (entry?.statusIndex == statusIndex ? "bx-fade-right" : "")
              }
            >
              <i className="bx bx-right-arrow-circle font-size-18"></i>
            </div>
            <div className="d-flex">
              <div className="flex-shrink-0 me-3">
                <h5 className="font-size-14">
                  {moment(entry?.dateOfferUploaded).format("DD.MM.YYYY")}{" "}
                  <i className="bx bx-right-arrow-alt font-size-16 text-primary align-middle ms-2"></i>
                </h5>
              </div>
              <div className="flex-grow-1">
                <div>Offer provided by Repair Lab</div>
              </div>
            </div>
            <div className="d-flex align-items-center mt-3">
              <div style={{ width: "45px" }}>
                <div className="avatar-sm">
                  <span className="avatar-title rounded-circle bg-primary bg-soft text-primary font-size-24">
                    <i className="bx bxs-file-doc" />
                  </span>
                </div>
              </div>
              <div className=" ms-4">
                <h5 className="font-size-14 mb-1">Repair Offer</h5>
                <small>Klick To Download</small>
              </div>
              <div className="text-center ms-4">
                <i className="bx bx-download h3 m-0" />
              </div>
            </div>
          </a>
          {(entry?.agbFileURL || entry?.agbLink) && (
            <div className="mt-3">
              <a
                href={entry?.agbFileURL ?? entry?.agbLink}
                target="_blank"
                rel="noreferrer"
              >
                <i className="bx bx-link-external me-1" />
                Terms & conditions of the repair lab
              </a>
              {entry?.dateAgbAcceptedRequestor && (
                <span className="badge bg-success px-2 py-1 ms-2">
                  Accepted{" "}
                  {moment(entry?.dateAgbAcceptedRequestor).format("DD.MM.YYYY")}
                </span>
              )}
            </div>
          )}
          <div className="mt-4">
            <b> Status:</b>
          </div>
          <div className="d-flex mt-2">
            <div>Requestor Confirmation: </div>
            <div className="ms-2">
              {entry?.dateOfferAcceptedRequestor ? (
                <span className="badge bg-success px-2 py-1">Confirmed</span>
              ) : entry?.dateOfferDeclinedRequestor ? (
                <span className="badge bg-danger px-2 py-1">Declined</span>
              ) : (
                <span className="badge bg-warning px-2 py-1">
                  {entry?.dateOfferDeclinedSeller ? "-" : "Pending"}
                </span>
              )}
            </div>
          </div>

          {entry?.offerDeclinedMessage && (
            <div className="mt-3">
              <b>Reason: </b>
              <p>{entry?.offerDeclinedMessage}</p>
            </div>
          )}
        </li>
      ) : (
        <>
          {entry?.statusIndex == statusIndex - 1 &&
            entry?.repairLaborID == myUser?.company?.id && (
              <RepairOfferFileDrop entry={entry} reload={reload} />
            )}
        </>
      )}
    </>
  )
}

export default RepairOfferListItem
